import { Drawer } from "@heroui/react";
import LoopDetailsComp from "../loops/loop-details-comp";

const LoopDetailsDrawer = ({ state, _loop_id, }) => {
  return (
    <Drawer state={state}>
      <Drawer.Backdrop variant="blur" className="bg-black/30">
        <Drawer.Content placement="right" >
          <Drawer.Dialog  className={'min-w-[500px]'}>
            <Drawer.Body className="overflow-y-auto shadow-none text-foreground">
              <LoopDetailsComp _loop_id={_loop_id} onClose={() => state.close()} />
            </Drawer.Body>
          </Drawer.Dialog>
        </Drawer.Content>
      </Drawer.Backdrop>
    </Drawer>
  );
};

export default LoopDetailsDrawer;
